import { useContext } from 'react';
import { Context } from '../context/Context';
import { useNavigate } from 'react-router-dom';
import { getAdminObject, isImpersonated, removeAdminFromLocalStorage } from '../helpers/impersonate';
import axios from 'axios';
import config from '../config';

const useLogout = (onClick) => {
  const context = useContext(Context);
  const navigate = useNavigate();

  const createLogoutEvent = async (isAdmin, userType, userEmail, adminEmail) => {
    const userContent = `${userType?.toUpperCase()} : ${userEmail}`;
    const content = isAdmin
      ? `ADMIN : ${adminEmail} s'est déconnecté en tant que 
        ${userContent}`
      : `${userContent} s'est déconnecté`;

    if (userType === 'student' || userType === 'pro') {
      await axios.post(`${config.API_URL}/api/logs`, {
        type: 'success',
        content,
      });
    }
  };

  const logout = async () => {
    onClick();

    const user = context.state?.user;
    const userType = user?.account?.type;

    if (isImpersonated()) {
      const admin = getAdminObject();
      removeAdminFromLocalStorage();
      await axios.put(`${config.API_URL}/api/users/admin/impersonate/end`).catch(() => { });
      await createLogoutEvent(true, userType, user?.email, admin.email);

      context.updateUser(admin);
      navigate('/tableau-de-bord', { replace: true });
    } else {
      await axios.post(`${config.API_URL}/public/auth/logout`);
      await createLogoutEvent(false, userType, user?.email);

      context.updateUser({});
      navigate('/auth/connexion', { replace: true });
    }
  };

  return logout;
};

export default useLogout;
